import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Section } from "@/lib/types";

interface AccordionSectionProps {
  sections: Section[];
  title?: string;
}

export default function AccordionSection({ sections, title = "Metodología" }: AccordionSectionProps) {
  const [open, setOpen] = useState<string | null>(sections[0]?.id ?? null);

  return (
    <div className="space-y-2">
      {title && (
        <h3
          className="text-xl font-semibold text-[var(--riee-purple)] mb-4"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          {title}
        </h3>
      )}
      {sections.map((sec) => (
        <div key={sec.id} className="border border-[var(--border)] rounded-lg overflow-hidden">
          <button
            className="accordion-header w-full text-left"
            onClick={() => setOpen(open === sec.id ? null : sec.id)}
            aria-expanded={open === sec.id}
          >
            <span
              className="font-semibold text-[var(--foreground)]"
              style={{ fontFamily: "var(--font-serif)", fontSize: "1rem" }}
            >
              {sec.title}
            </span>
            <ChevronDown
              size={16}
              className={`text-[var(--riee-gold)] flex-shrink-0 transition-transform duration-200 ${
                open === sec.id ? "rotate-180" : ""
              }`}
            />
          </button>
          {open === sec.id && (
            <div className="px-5 pb-5 pt-3 bg-white">
              {sec.content.map((p, i) => (
                <p key={i} className="text-gray-700 leading-relaxed text-sm mb-3 last:mb-0">
                  {p}
                </p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
